import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={14.683}
    height={25.701}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 5468 9572"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m765 6666 3141 1 377 2536-3900-7 382-2530zm4332-4339c65 308 15 1408 16 1812 1 751-248 855-991 846l395-2648 580-10zM3563 6294l-2455 3-723-4853 3903-1c-33 389-122 843-181 1234-59 400-118 795-178 1194-86 577-273 2001-366 2423zM395 1067c78-352 440-412 746-410h2383c283-1 710 53 751 415l-3880-5zM87 8741c-95 1024-552 813 2185 813 330 0 2178 53 2319-35 154-102 36-479-14-809-45-296-91-587-134-877l-201-1328c-39-211-103-195-309-209l185-943c160-44 320 14 557-34 589-116 790-515 789-1149-1-428 0-856 0-1283 0-428 72-856-373-917l-518-11c-3-109-12-50 27-96 5-310 125-526 48-833-233-931-1293-724-2117-724V0l-375 4-7 302c-717 0-1555-127-1920 324C49 853-33 1092 23 1440c77 474 712 4620 716 4860l-249 30C352 6632 194 8433 87 8741z"
        className="fil0"
      />
      <path
        d="M2150 7366c377-103 728 115 828 374 146 374-154 682-443 757-853 223-1253-894-385-1131zm-722 744c241 1034 2032 781 1822-333-202-1077-2088-803-1822 333z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
